/* eslint-disable import/prefer-default-export */
import { useCallback } from 'react';

// global state to manage refresh triggers for any trigger name
const globalRefreshTriggers: { [triggerName: string]: number } = {};
const globalRefreshListeners: Set<() => void> = new Set();

export const resetTriggerState = () => {
  Object.keys(globalRefreshTriggers).forEach(key => {
    delete globalRefreshTriggers[key];
  });
  globalRefreshListeners.clear();
};

// hook to manage refresh triggers
// good for cross-component data invalidation and simple refresh/reload patterns
export const useDataRefresh = () => {
  const subscribe = useCallback((callback: () => void) => {
    globalRefreshListeners.add(callback);
    return () => {
      globalRefreshListeners.delete(callback);
    };
  }, []);

  const triggerRefresh = useCallback((triggerName: string) => {
    globalRefreshTriggers[triggerName] =
      globalRefreshTriggers[triggerName] ?? 0;
    globalRefreshTriggers[triggerName] += 1;
    globalRefreshListeners.forEach(listener => listener());
  }, []);

  const getTrigger = useCallback((triggerName: string): number => {
    return globalRefreshTriggers[triggerName] || 0;
  }, []);

  return {
    subscribe,
    triggerRefresh,
    getTrigger
  };
};
